import { theme } from '@styles/theme';
import { Dispatch, FC, SetStateAction } from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';

type HandleRemainingModalProps = {
  isOpen: boolean;
  closeModal: Dispatch<SetStateAction<boolean>>;
  data: any;
  replaceRemaining: Dispatch<SetStateAction<boolean>>;
};
const HandleRemainingModal: FC<HandleRemainingModalProps> = (props) => {
  const closeConfirmationModal = () => {
    props.closeModal(false);
  };

  const replace = () => {
    props.replaceRemaining(true);
  };

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={closeConfirmationModal}
      style={modalStyles}
      contentLabel='Save Modal'
      ariaHideApp={false}
    >
      <ModalBodyWrapper>
        You replaced <b>{props.data.done}</b> out of <b>{props.data.total}</b> vehicles. Would you
        like to replace the remaining <b>{props.data.remaining}</b> vehicles?
      </ModalBodyWrapper>

      <Footer>
        <FooterButtonPanel>
          <Button onClick={closeConfirmationModal} className={'cancel'}>
            CLOSE
          </Button>
          <Button onClick={replace} className={'save-button'}>
            REPLACE REMAINING
          </Button>
        </FooterButtonPanel>
      </Footer>
    </Modal>
  );
};

export default HandleRemainingModal;

const modalStyles = {
  content: {
    top: '20%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, 2%)',
    width: '460px',
    minHeight: '190px',
    maxHeight: '640px',
    zIndex: 100000,
    padding: '0',
    borderRadius: '8px',
  },
};

const ModalBodyWrapper = styled.div`
  padding: 40px;
`;

const FooterButtonPanel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  margin-right: 20px;
  margin-left: 22px;
  .cancel {
    background-color: #ddd;
    border-bottom: 1px solid silver;
    color: #333;
    :hover {
      cursor: pointer;
      background-color: ${theme.palette.backgroundGray};
    }
  }
  .save-button {
    background-color: #593487;
    color: #fff;
    border: 1px solid #593487;
    :hover {
      cursor: pointer;
      background-color: #775ea5;
    }
  }
`;

const Button = styled.button`
  border-radius: 3px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  height: 35px;
  margin-left: 15px;
  padding: 0px 10px;
  border: 0px;
  &:disabled {
    background-color: ${theme.palette.gainsboro};
  }
`;

const Footer = styled.div`
  background-color: ${theme.palette.white};
  border-top: 1px solid ${theme.palette.background};
  width: 100%;
`;
